export * from './addressBook.service';
import { AddressBookService } from './addressBook.service';
export * from './addressBookContact.service';
import { AddressBookContactService } from './addressBookContact.service';
export * from './aggregator.service';
import { AggregatorService } from './aggregator.service';
export * from './aqnApiKey.service';
import { AqnApiKeyService } from './aqnApiKey.service';
export * from './area.service';
import { AreaService } from './area.service';
export * from './category.service';
import { CategoryService } from './category.service';
export * from './client.service';
import { ClientService } from './client.service';
export * from './clientRoutingService.service';
import { ClientRoutingServiceService } from './clientRoutingService.service';
export * from './content.service';
import { ContentService } from './content.service';
export * from './contentProvider.service';
import { ContentProviderService } from './contentProvider.service';
export * from './contentTransactionLogs.service';
import { ContentTransactionLogsService } from './contentTransactionLogs.service';
export * from './country.service';
import { CountryService } from './country.service';
export * from './industry.service';
import { IndustryService } from './industry.service';
export * from './industryDnd.service';
import { IndustryDndService } from './industryDnd.service';
export * from './mapContentToServiceProivider.service';
import { MapContentToServiceProividerService } from './mapContentToServiceProivider.service';
export * from './mapServiceToClient.service';
import { MapServiceToClientService } from './mapServiceToClient.service';
export * from './operatorDetails.service';
import { OperatorDetailsService } from './operatorDetails.service';
export * from './operators.service';
import { OperatorsService } from './operators.service';
export * from './service.service';
import { ServiceService } from './service.service';
export * from './serviceContentMap.service';
import { ServiceContentMapService } from './serviceContentMap.service';
export * from './serviceDndSubscription.service';
import { ServiceDndSubscriptionService } from './serviceDndSubscription.service';
export * from './serviceProvider.service';
import { ServiceProviderService } from './serviceProvider.service';
export * from './serviceProviderUploadedDocumentsMap.service';
import { ServiceProviderUploadedDocumentsMapService } from './serviceProviderUploadedDocumentsMap.service';
export * from './serviceSubscribers.service';
import { ServiceSubscribersService } from './serviceSubscribers.service';
export * from './serviceTransactionLogs.service';
import { ServiceTransactionLogsService } from './serviceTransactionLogs.service';
export * from './shortCode.service';
import { ShortCodeService } from './shortCode.service';
export * from './smsDelivery.service';
import { SmsDeliveryService } from './smsDelivery.service';
export * from './sqlDataMigration.service';
import { SqlDataMigrationService } from './sqlDataMigration.service';
export * from './tenant.service';
import { TenantService } from './tenant.service';
export * from './utility.service';
import { UtilityService } from './utility.service';
export * from './vasProviderRoles.service';
import { VasProviderRolesService } from './vasProviderRoles.service';
export const APIS = [AddressBookService, AddressBookContactService, AggregatorService, AqnApiKeyService, AreaService, CategoryService, ClientService, ClientRoutingServiceService, ContentService, ContentProviderService, ContentTransactionLogsService, CountryService, IndustryService, IndustryDndService, MapContentToServiceProividerService, MapServiceToClientService, OperatorDetailsService, OperatorsService, ServiceService, ServiceContentMapService, ServiceDndSubscriptionService, ServiceProviderService, ServiceProviderUploadedDocumentsMapService, ServiceSubscribersService, ServiceTransactionLogsService, ShortCodeService, SmsDeliveryService, SqlDataMigrationService, TenantService, UtilityService, VasProviderRolesService];
